<template>
  <div class="sliding-list">
    <PersonList :persons="persons" v-slot="{ person }">
      <slot :person="person" />
    </PersonList>
  </div>
</template>

<script>
import PersonList from './PersonList.vue';

export default {
  name: 'SlidingList',
  components: {
    PersonList,
  },
  props: {
    persons: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    slideDelay: 4000,
  }),
};
</script>

<style lang="scss">
.person-list {
  height: 100%;
  width: 100%;
}
</style>
